module.exports = __webpack_public_path__ + "media/icons/portfolio-funding-e12f5ce7.png";